/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_House_NumberInputs */

const cs_form_house_number = /** @type {(inputs: Form_House_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Číslo popisné (č.p.)`)
};

const en_form_house_number = /** @type {(inputs: Form_House_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descriptive number (č.p.)`)
};

/**
* | output |
* | --- |
* | "Descriptive number (č.p.)" |
*
* @param {Form_House_NumberInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_house_number = /** @type {((inputs?: Form_House_NumberInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_House_NumberInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_house_number(inputs)
	return cs_form_house_number(inputs)
});